import React, { useEffect } from "react";
import "./App.css";
import HomeScreen from "./screens/HomeScreen";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import Login from "./screens/Login";
import { auth,onAuthStateChanged } from "./firebase";
import { useDispatch, useSelector } from "react-redux";
import { login, logout, selectUser } from "./features/userSlice";
import ProfileScreen from "./screens/ProfileScreen";

function App() {
  const user = useSelector(selectUser);
  const dispatch = useDispatch()
useEffect(() => {
  const unsubscribe = onAuthStateChanged(auth, (userAuth) => {
    if (userAuth){
      // Logged in
      dispatch(login({
        uid: userAuth.uid,
        email: userAuth.email
      }))
    }else{
      // Logged out
      dispatch(logout())
    }
  })
  return unsubscribe;
},[dispatch])


  return (
    <div className="app">
      <Router>
        {!user ? <Login/> : <Routes>
        <Route exact path="/" element={<HomeScreen />}></Route>
        <Route exact path="/profile" element={<ProfileScreen/>}></Route>
      </Routes> }
      
      </Router>
      
    </div>
  );
}

export default App;
